/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowrefineneon3Inputs */

const en_aiflowrefineneon3 = /** @type {(inputs: Aiflowrefineneon3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`More neon`)
};

const de_aiflowrefineneon3 = /** @type {(inputs: Aiflowrefineneon3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mehr Neon`)
};

/**
* | output |
* | --- |
* | "More neon" |
*
* @param {Aiflowrefineneon3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowrefineneon3 = /** @type {((inputs?: Aiflowrefineneon3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowrefineneon3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowrefineneon3(inputs)
	return de_aiflowrefineneon3(inputs)
});
export { aiflowrefineneon3 as "aiFlowRefineNeon" }